import { ExtraOptionsKeys, MethodOfEnergyGeneration, PowerRequirements } from "./index250.js";
import { SpacesList } from "@project-rouge/rg-core";
const TechSpacePresetTranslatorRulesLib = {
	[MethodOfEnergyGeneration.AmbientLoop]: {
		forceInvalid: true,
		userDefinedAttributes: { DistrictHeating: true }
	},
	[MethodOfEnergyGeneration.DistrictHeating]: {
		forceInvalid: true,
		userDefinedAttributes: { EnergyCentre: true }
	},
	[MethodOfEnergyGeneration.LocalHeatPumps]: {
		forceInvalid: true,
		userDefinedAttributes: { CentralASHP: true }
	},
	[PowerRequirements.PLV]: { forceInvalid: true },
	[PowerRequirements.PLVandSecondary]: {
		forceInvalid: true,
		optionalSpaces: findSpaceByPartialName("Electrical Secondary LV Room")
	},
	[PowerRequirements.PLVandGenerator]: {
		forceInvalid: true,
		userDefinedAttributes: { Generator: true }
	},
	[ExtraOptionsKeys.Sprinklers]: {
		forceInvalid: true,
		userDefinedAttributes: { Sprinklered: true }
	},
	[ExtraOptionsKeys.ElectricalSubstation]: {
		forceInvalid: true,
		optionalSpaces: findSpaceByPartialName("Electrical Substation")
	},
	[ExtraOptionsKeys.Rainwater]: {
		forceInvalid: true,
		optionalSpaces: findSpaceByPartialName("Tank Room Rainwater Harvesting")
	},
	[ExtraOptionsKeys.Greywater]: {
		forceInvalid: true,
		optionalSpaces: findSpaceByPartialName("Tank Room Black_Grey Water Harvesting")
	},
	[ExtraOptionsKeys.ExternalGenerator]: {
		forceInvalid: true,
		optionalSpaces: findSpaceByPartialName("Generator Room Lowest Level")
	}
};
function findSpaceByPartialName(partial) {
	const space = SpacesList.find((space$1) => space$1.name.includes(partial));
	return space ? [space] : [];
}
export { TechSpacePresetTranslatorRulesLib };

//# sourceMappingURL=index252.js.map